import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals, { sendToAnalytics } from './reportWebVitals';
import ErrorBoundary from './component/ErrorBoundary';
import './index.css';
import './component/css/animations.css';
import './component/css/icon-fallback.css';
import initScrollAnimations from './utils/scrollAnimation';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ErrorBoundary>
        <HelmetProvider>
            <App/>
        </HelmetProvider>
    </ErrorBoundary>
);

// ส่ง Web Vitals ไป Google Analytics
reportWebVitals(sendToAnalytics);

// Initialize scroll animations
initScrollAnimations();
